export default "__VITE_ASSET__DDIU1BaU__"